import React, {
    PropTypes,
} from 'react';
import {Table, Glyphicon} from 'react-bootstrap';
import MenuItem from './MenuItem';
import {Dialog} from '../../components';

class MenuOrder extends React.Component {
    static propTypes = {
        menu: PropTypes.object.isRequired,
        onQuantityChange: PropTypes.func.isRequired,
    };

    state = {
        requestShow: false,
        requestTxt: '',
    };

    onChange(id, oldCount, name, count) {
        if (oldCount < count && count > 3) {
            this.setState({
                requestShow: true,
                requestTxt: 'Вы уверены, что хотите заказать блюдо "' + name + '" в кол-ве ' + count + ' шт?',
                requestOk: () => this.props.onQuantityChange(id, count)
            });
        } else {
            this.props.onQuantityChange(id, count);
        }
    }

    render() {
        const {menu} = this.props;
        return (
            <div>
                <Table condensed hover className="mb0 my-table">
                    <thead>
                    <tr>
                        <th>Блюдо</th>
                        <th className="hidden-xs hidden-sm text-right"><Glyphicon glyph="scale"/></th>
                        <th className="hidden-xs text-right">₴</th>
                        <th className="text-center">Кількість</th>
                        <th className="hidden-xs text-right">Разом</th>
                    </tr>
                    </thead>
                    <tbody>
                    {menu.wares.map(ware =>
                        <MenuItem
                            onChange={this.onChange.bind(this, ware.priceWaresId, ware.waresQuantity, ware.waresName)}
                            {...ware} />
                    )}
                    </tbody>
                </Table>
                <Dialog
                    show={this.state.requestShow}
                    body={this.state.requestTxt}
                    title="Вы точно можете столько съесть?"
                    yesTitle="Да"
                    yes={() => {
                        this.state.requestOk();
                        this.setState({requestShow: false})
                    }}
                    noTitle="Нет, спасибо"
                    no={() => this.setState({requestShow: false})}
                />
            </div>
        );
    }
}

export default MenuOrder;



/** WEBPACK FOOTER **
 ** ./src/modules/food/MenuOrder.js
 **/